// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"809":"72131cbee0ffe503","920":"739f582baceeafab","1260":"e0185e6afd420c19","3877":"fe336940f98fdfab","6047":"39a52b3cdcf8e8ed","6272":"aa4472f7082b94cd"}[chunkId] + ".css";
};